import React from "react";
import { useRegisterStateValue } from "../../RegisterContext";
import { withLocalizeStrings } from "../../../languages/Localize";
import { Box, Flex } from "reflexbox/styled-components";
import styled from "styled-components";
import { Button } from "antd";
import { Anchor } from "antd";

const { Link } = Anchor;

const StyledParagraph = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.transparent};
    text-align: center;
`;

const StyledDescription = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.transparent};
    text-align: justify;
`;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.hover};
    width: 100%;
    height: 50px;
    border: none;
    font-size: inherit;
    text-transform: uppercase;
    &:focus,
    &:hover {
        background: ${({ theme }) => theme.colors.hover};
        color: ${({ theme }) => theme.colors.white};
    }
    &:active {
        background: ${({ theme }) => theme.colors.active};
        color: ${({ theme }) => theme.colors.white};
    }
`;

const StyledHeader = styled(Flex)`
    flex-direction: column;
    align-items: center;
    .divider {
        background: ${({ theme }) => theme.colors.white};
        width: 30px;
        height: 3px;
    }
`;

const StyledHeaderLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
`;

const StyledAnchor = styled(Anchor)`
    & {
        background: transparent;
    }
    && .ant-anchor-link-title {
        color: ${({ theme }) => theme.colors.white};
    }
    && .ant-anchor-ink::before {
        display: none;
    }
    && .ant-anchor-link {
        padding: 16px;
        text-align: center;
    }
`;

const RegistrationFeeScreen = ({ strings }) => {
    const { nextScreen, backScreen } = useRegisterStateValue();

    return (
        <>
            <StyledHeader>
                <StyledHeaderLabel sx={{ fontWeight: "light", fontSize: [5, 6], mt: [3, 4], p: [1, 2] }}>
                    {strings.register.common.REGISTRATION_FEE_HEADER}
                </StyledHeaderLabel>
                <div className="divider" />
            </StyledHeader>
            <StyledParagraph sx={{ mx: [3, 4], marginTop: [3, 4], paddingTop: [3, 4], px: [1, 2], fontSize: [1, 2] }}>
                {strings.register.common.REGISTRATION_FEE_CAPTION}
            </StyledParagraph>
            <StyledParagraph sx={{ mx: [3, 4], px: [1, 2], fontSize: [2, 3], fontWeight: "bold" }}>
                {strings.register.common.REGISTRATION_FEE_BANK_ACCOUNT_NUMBER}
            </StyledParagraph>
            <StyledParagraph sx={{ mx: [3, 4], px: [1, 2], fontSize: [1, 2] }}>
                {strings.register.common.REGISTRATION_FEE_BANK_ACCOUNT}
            </StyledParagraph>
            <StyledParagraph sx={{ mx: [3, 4], paddingBottom: [3, 4], px: [1, 2], fontSize: [1, 2] }}>
                {strings.register.common.REGISTRATION_FEE_RECEPIENT_INFO}
            </StyledParagraph>
            <StyledParagraph sx={{ mx: [3, 4], px: [1, 2], fontSize: [1, 2] }}>
                {strings.register.common.REGISTRATION_FEE_PARTICIPANT_CAPTION}
            </StyledParagraph>
            <StyledParagraph sx={{ mx: [3, 4], px: [1, 2], fontSize: [2, 3], fontWeight: "bold" }}>
                {strings.register.common.REGISTRATION_FEE_PARTICIPANT_PRICE}
            </StyledParagraph>
            <StyledDescription sx={{ mx: [3, 4], px: [3, 4], paddingBottom: [3, 4], fontSize: [1, 2] }}>
                {strings.register.common.REGISTRATION_FEE_PARTICIPANT_INFO}
            </StyledDescription>
            <StyledButtonContainer sx={{ marginTop: [3, 4], marginX: [3, 4], marginBottom: 0, px: [1, 2], fontSize: [2, 3] }}>
                <StyledButton onClick={nextScreen}>{strings.register.common.REGISTRATION_FEE_BUTTON}</StyledButton>
            </StyledButtonContainer>
            <StyledAnchor className="link" affix={false} onClick={backScreen}>
                <Link title={strings.register.common.BACK_LABEL} />
            </StyledAnchor>
        </>
    );
};
export default withLocalizeStrings(RegistrationFeeScreen);
